/* Globo V2 — Stepped product options */
(() => {

  function getConfigs() {
    const G = window.GPOConfigs;
    if (!G) return [];
    if (Array.isArray(G.options)) return G.options.filter(o => o && o.enable !== false);
    if (Array.isArray(G)) return G.filter(o => o && o.enable !== false);
    return [];
  }

  function extractPrice(elements) {
    for (const el of (elements || [])) {
      if (el.addon_product && el.addon_product.variant_price) return el.addon_product.variant_price;
      const found = extractPrice(el.elements);
      if (found !== null) return found;
    }
    return null;
  }

  function formatPrice(raw) {
    const n = parseFloat(raw);
    if (!n) return null;
    return '+$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function isComplete(group) {
    for (const el of group.querySelectorAll('input[type="text"], input:not([type])')) {
      if (el.disabled) continue;
      const min = parseInt(el.getAttribute('minlength') || el.dataset.minlength || 0);
      if (min > 0 && el.value.trim().length < min) return false;
    }
    const radio = {};
    for (const r of group.querySelectorAll('input[type="radio"]')) {
      if (!radio[r.name]) radio[r.name] = { any: false, checked: false };
      if (!r.disabled) radio[r.name].any = true;
      if (r.checked)   radio[r.name].checked = true;
    }
    return Object.values(radio).every(g => !g.any || g.checked);
  }

  const CHECK = `<span class="globo-v2__check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="#000"/><path d="M4.5 8.5l2.5 2.5 4.5-5.5" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
  const SWITCH = `<span class="globo-v2__switch" aria-hidden="true"><span class="globo-v2__switch-knob"></span></span>`;

  class GloboV2 extends HTMLElement {
    connectedCallback() { this._wait(); }

    _wait() {
      if (this._findGroups()) return;
      const root = this.closest('.shopify-section') || document.body;
      const obs  = new MutationObserver(() => { if (this._findGroups()) obs.disconnect(); });
      obs.observe(root, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 8000);
    }

    _findGroups() {
      const scope  = this.closest('.shopify-section') || document;
      const groups = Array.from(scope.querySelectorAll('.gpo-group__wrapper'));
      if (!groups.length) return false;
      setTimeout(() => this._setup(groups), 400);
      return true;
    }

    _setup(groups) {
      const configs = getConfigs();

      this.steps = groups.map((group, i) => {
        const cfg = configs[i] || {};
        let label = cfg.name || null;
        if (!label) {
          const lc = group.querySelector('.label-content');
          if (lc) label = lc.textContent.trim();
        }
        label = label || `Option ${i + 1}`;

        let price = null;
        const addOn = group.querySelector('.addOn');
        if (addOn?.textContent.trim()) price = addOn.textContent.replace(/[()]/g, '').trim();
        if (!price) price = formatPrice(extractPrice(cfg.elements));

        return { group, label, price };
      });

      this.steps.forEach((step, i) => {
        const { group } = step;
        const gpoGroup  = group.parentNode;
        const container = gpoGroup.parentNode;

        const total = container.querySelector('.gpo-total');
        if (total) total.style.display = 'none';

        const accordion = document.createElement('div');
        accordion.className = 'globo-v2__accordion';
        if (i > 0) accordion.classList.add('globo-v2__accordion--locked');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'globo-v2__toggle';
        this._setOff(btn, i);
        btn.addEventListener('click', () => {
          if (accordion.classList.contains('globo-v2__accordion--locked')) return;
          btn.getAttribute('aria-pressed') === 'true'
            ? this._close(i)
            : this._open(i);
        });

        const body = document.createElement('div');
        body.className = 'globo-v2__body';

        container.insertBefore(accordion, gpoGroup);
        body.appendChild(gpoGroup);
        accordion.appendChild(btn);
        accordion.appendChild(body);

        step.btn       = btn;
        step.body      = body;
        step.accordion = accordion;
        step.total     = container.querySelector('.gpo-total');
      });
    }

    _labelHTML(i) {
      const { label, price } = this.steps[i];
      const priceStr = price ? ` for <strong>${price}</strong>` : '';
      return `${CHECK}<span class="globo-v2__toggle-label">Add <strong>${label}</strong>${priceStr}</span>${SWITCH}`;
    }

    _setOff(btn, i) {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('is-active');
      btn.innerHTML = this._labelHTML(i);
    }

    _setOn(btn, i) {
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('is-active');
      btn.innerHTML = this._labelHTML(i);
    }

    _open(i) {
      const step = this.steps[i];
      const { btn, body, accordion, group, total } = step;
      this._setOn(btn, i);
      accordion.classList.add('is-open');
      body.style.overflow = 'hidden';
      body.style.maxHeight = body.scrollHeight + 'px';
      body.addEventListener('transitionend', () => {
        body.style.overflow = 'visible';
      }, { once: true });
      if (total) total.style.display = '';

      const onChange = () => {
        const done = isComplete(group);
        accordion.classList.toggle('is-done', done);
        if (done) {
          const next = this.steps[i + 1];
          if (next) next.accordion.classList.remove('globo-v2__accordion--locked');
        }
      };

      // Store so _close can remove it
      if (step._onChange) {
        group.removeEventListener('input',  step._onChange);
        group.removeEventListener('change', step._onChange);
      }
      step._onChange = onChange;

      group.addEventListener('input',  onChange);
      group.addEventListener('change', onChange);
      setTimeout(onChange, 0);
    }

    _close(i) {
      const step = this.steps[i];
      const { btn, body, accordion, group, total } = step;

      if (step._onChange) {
        group.removeEventListener('input',  step._onChange);
        group.removeEventListener('change', step._onChange);
        step._onChange = null;
      }

      this._setOff(btn, i);
      accordion.classList.remove('is-open', 'is-done');
      body.style.overflow = 'hidden';
      body.style.maxHeight = '0';
      if (total) total.style.display = 'none';
      group.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(el => { el.value = ''; });
      group.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(el => { el.checked = false; });
    }
  }

  if (!customElements.get('globo-v2')) customElements.define('globo-v2', GloboV2);
})();
